import Page from 'src/components/page/page';
import useScnEventsDetails from './scn-events-details.hook';
import { Box, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import CNLoading from 'src/components/loading-cn/CNLoading';
import ScnEventsForm from './components/scn-events-form';

export default function ScnEventsDetails() {
  const { isEdit, loadingScnEventDetails, methods, control, isSubmitting, STATUS_OPTIONS, STATUS_LABEL, onSubmit, navigate } = useScnEventsDetails();

  return (
    <Page title={isEdit ? 'Editar Evento SCN' : 'Cadastrar Evento SCN'}>
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading={isEdit ? 'Editar Evento SCN' : 'Cadastrar Evento SCN'}
          links={[]}
        />
        {loadingScnEventDetails ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <ScnEventsForm
            methods={methods}
            control={control}
            isEdit={isEdit}
            isSubmitting={isSubmitting}
            statusOptions={STATUS_OPTIONS}
            statuslabel={STATUS_LABEL}
            onSubmit={onSubmit}
            navigate={navigate}
          />
        )}
      </Container>
    </Page>
  );
}
